import { createSlice } from '@reduxjs/toolkit';

const MAX_STORED_EVENTS = 100;

const initialState = {
  events: [],
  lastEvent: null,
};

const realtimeNotificationsSlice = createSlice({
  name: 'realtimeNotifications',
  initialState,
  reducers: {
    eventReceived: (state, action) => {
      const event = {
        ...action.payload,
        receivedAt: action.payload?.receivedAt || Date.now(),
      };

      state.events.push(event);
      state.lastEvent = event;

      if (state.events.length > MAX_STORED_EVENTS) {
        state.events.splice(0, state.events.length - MAX_STORED_EVENTS);
      }
    },
    clearEvents: (state) => {
      state.events = [];
      state.lastEvent = null;
    },
  },
});

export const { eventReceived, clearEvents } = realtimeNotificationsSlice.actions;

export default realtimeNotificationsSlice.reducer;

